import _ from 'lodash';
import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {CampaignOptionLeaderModel} from '../../../models/campaign-option-leader.model';
import {Observable} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {selectVirtualEventActivity} from '../../../features/activity/activity.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-current-auction-option',
  templateUrl: './current-auction-option.component.html',
  styleUrls: ['./current-auction-option.component.scss']
})
export class CurrentAuctionOptionComponent implements OnChanges {
  @Input() campaign: any = null;
  @Input() option: any = null;
  @Input() event: any = null;
  @Input() raised: any = 0;

  public count: number = null;
  public soldCount: number = null;
  public available: number = null;
  public leader: CampaignOptionLeaderModel = null;
  public activities$: Observable<any> = this.store.pipe(select(selectVirtualEventActivity));
  public lastActivity: any;
  public activities: any;

  constructor(
    private store: Store<any>
  ) {
    this.activities$.pipe(takeUntilDestroyed()).subscribe(activities => {
      this.lastActivity = null;
      this.activities = activities;

      if (activities && activities.entities && activities.entities.length) {
        this.lastActivity = activities.entities[0];
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const option = _.get(changes, 'option.currentValue', this.option);
    const soldCount = _.get(option, 'soldCount', 0);
    const bids = _.get(option, 'currentBids', []) || [];
    const count = _.get(option, 'count', 0);

    this.leader = bids.length > 0 ? new CampaignOptionLeaderModel(bids[0]) : null;

    if (this.leader) {
      this.leader.isWinner = soldCount > 0;
    }

    this.count = count;
    this.soldCount = soldCount;
    this.available = count - soldCount;
  }

  isNotEmpty(campaign) {
    return !_.isEmpty(campaign);
  }

  getImageUrl(option) {
    return option.imageUrl === '' ? '/images/org_logo_default_v2.svg' : option.imageUrl;
  }

  getCurrentBid() {
    const bids = _.get(this.option, 'currentBids', []) || [];
    const maxBid = _.maxBy(bids, function (bid) {
      return bid.amount;
    });
    return _.get(maxBid, 'amount', 0);
  }
}
